import Store from '@/Store';
import { NavigationGuardNext, Route } from 'vue-router';

/**
 * Handles social media redirections to authenticate our user.
 *
 * @return void
 */
export function QueryParameters(to: Route, from: Route, next: NavigationGuardNext): void {
	let queryParameters = JSON.parse(JSON.stringify(to.query));

	// Convert numbers and booleans
	for (let key in queryParameters) {
		if (queryParameters[key] === 'true') {
			queryParameters[key] = true;
		} else if (queryParameters[key] === 'false') {
			queryParameters[key] = false;
		} else if (!isNaN(queryParameters[key])) {
			queryParameters[key] = parseInt(queryParameters[key]);
		}
	}

	// Commit to memory
	Store.commit('setQueryParameters', queryParameters);

	next();
}
